<div style="position: relative; left: 10px; top: 10px;">
    <app-panel-logout></app-panel-logout>
</div>

<div class="vincent_container vincent_typography">
    <div class="row gutters">
        <div class="col col-12 vincent_content">
            <table class="vincent_cart cus-wid-3" style="position: relative; left: 60px;">
                <thead>
                    <tr>
                        <th class="th-1">الحالة</th>
                        <th class="th-1"><span>معلومات أضافية</span></th>
                        <th class="th-1">الطلب</th>
                        <th class="th-1"><span>رقم الطاولة</span></th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <div>
                        {{filtered | json}}
                    </div> -->
                    <tr class="vincent_cart_item" *ngFor="let info of filtered;" style="border-bottom: none;">

                        <div *ngIf="info.gstatus == true">
                            <td class="td-6">
                                <a class="vincent_button" (click)='deleteUser(info.id)'> حذف المستخدم </a>
                            </td>
                            <td class="td-5"> 
                                <button class="vincent_button" *ngIf="ordersLength != 0 || ordersSubInfoLength != 0" disabled>تم التحضير</button>
                                <a class="vincent_button" *ngIf="ordersLength == 0 && ordersSubInfoLength == 0" (click)="changeGstauts(info.id)">تم التحضير</a>
                            </td> 
                            <td class="vincent_product-name td-4">
                                <span *ngIf="info.gstatus == true">
                                    <a>مؤكد</a>  
                                </span>
                                <span *ngIf="info.gstatus !== true">
                                    <a> غير مؤكد</a>  
                                </span> 
                            </td>
                        
                            <td class="vincent_product-name td-3">
                                <span *ngIf="info.gstatus == true" (click)="getsub(info.id) ">
                                    <a (click)="basicModal2.show()">عرض المعلومات</a>
                                </span>
                            </td>
                        
                            <td class="vincent_product-price td-2">
    
                                <span  (click)="getorders(info.id) ">
                                    <a (click)="basicModal.show()">عرض الطلب</a>
                                </span>
                            </td>
                        
                            <td class="vincent_product-subtotal td-1">
                                {{info.tableno}}
                            </td>
                       
                            <p class="liner"></p>
                        </div>

                        <!-- view order model -->
                        <div style="overflow-y: scroll" mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-fluid " role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal.hide()">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                  <h4 class="modal-title w-100" id="myModalLabel">الطلبات</h4>
                                </div>
                                <div class="modal-body">
                                    <table class="vincent_cart cus-wid-2">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th>الصنف</th>
                                                <th><span>السعر</span></th>
                                                <th>الكمية</th>
                                                <th><span>الأجمالي</span></th>
                                            </tr>
                                        </thead>
                                        <tbody ng-init="total = 0">
                                            <tr class="vincent_cart_item" *ngFor="let info2 of orders;index as i">
                                                <td>
                                                    <a class="vincent_button" (click)="delete(i,info.id)"> تم التحضير </a>
                                                        <div class="alert alert-danger cus" role="alert" style="display: none;" id="done">
                                                            تم  التأكيد             
                                                        </div> 
                                                </td>
                                                <td class="vincent_product-thumbnail">
                                                    <img [src]="info2.photo">
                                                </td>
                                                <td class="vincent_product-name" data-title="Product">
                                                    {{info2.title_ar}}
                                                </td>
                                                <td class="vincent_product-price" data-title="Price">
                                                    <span> ريال - {{info2.price}}</span>
                                                </td>
                                                <td  class="vincent_product-quantity"  data-title="Quantity">
                                                    <span>{{info2.amount}}</span>
                                                </td>
                                                <td class="vincent_product-subtotal" data-title="Total">
                                                    <span>  ريال - {{info2.price * info2.amount}}</span>
                                                    <span *ngIf="sum == true">{{recieve(info2.price * info2.amount)}}</span>
                                                </td>
                                            </tr>
                                         </tbody>
                                    </table>
                                    <div class="vincent_cart_totals" style="float: right;">
                                        <h5 class="right">تفاصيل الحساب</h5>
                                        <table class="table-cus">
                                            <tbody>
                                                <tr>
                                                    <td class="right">
                                                         <p class="xtotal"> {{"total" | translate}} = {{totalll}} / {{"sar" | translate}} </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                     <td><span class="xtotal"> {{"tax" | translate}} = {{tax}}</span></td>
                                                </tr>
                                                <tr>
                                                    <td><span class="xtotal"> {{"all" | translate}} = {{all}} / {{"sar" | translate}}</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal.hide()" mdbWavesEffect>غلق</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        <!-- end view order model -->
                        <!-- view sub order model -->
                        <div style="overflow-y: scroll" mdbModal #basicModal2="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="close pull-right" aria-label="Close" (click)="basicModal2.hide()">
                                    <span aria-hidden="true">×</span>
                                  </button>
                                  <h4 class="modal-title w-100" id="myModalLabel">بيانات أضافية</h4>
                                </div>
                                <div class="modal-body">
                                    <table class="vincent_cart cus-wid">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th> الدفع</th>
                                                <th><span>الرسالة</span></th>
                                                <th><span>الحالة</span></th>
                                            </tr>
                                        </thead>
                                        <tbody ng-init="total = 0">
                                            <tr class="vincent_cart_item" *ngFor="let info3 of subInfo;index as i">
                                                <td>
                                                    <a class="vincent_button" (click)="deletesub(i,info.id)">تم التأكيد</a>
                                                </td>
                                                <td class="vincent_product-name">
                                                    <span>{{info3.selectedmethod}}</span>
                                                </td>
                                                <td class="vincent_product-name">
                                                    <span>{{info3.message}}</span>
                                                </td>
                                                <td  class="vincent_product-name">
                                                    <span>{{info3.status}}</span>
                                                </td>
                                            </tr>
                                            <div class="alert alert-danger cus" role="alert" style="display: none;" id="done2">
                                                تم  التأكيد             
                                            </div>
                                         </tbody>
                                    </table>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close" (click)="basicModal2.hide()" mdbWavesEffect>غلق</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        <!-- end view sub order model -->       
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>